import { DEFAULT_LANGUAGE } from "../i18n/config";

/**
 * Get the relative date string
 * @param date The date to get the relative date string from
 * @param locales The current language
 * @returns The relative date string
 */
export const getRelativeDateString = (date: Date, locales?: string) => {
    if (!date) return '';
    const now = new Date();
    const diffInMilliseconds = date.getTime() - now.getTime();
    const seconds = Math.round(diffInMilliseconds / 1000);
    const minutes = Math.round(seconds / 60);
    const hours = Math.round(minutes / 60);
    const days = Math.round(hours / 24);
    const months = Math.round(days / 30.44); // Average days in a month
    const years = Math.round(days / 365.25); // Average days in a year

    const rtf = new Intl.RelativeTimeFormat(locales || DEFAULT_LANGUAGE, { numeric: 'auto' }); // 'en' for English, 'auto' for "yesterday", "tomorrow"

    if (Math.abs(seconds) < 60) {
        return rtf.format(seconds, 'second');
    } else if (Math.abs(minutes) < 60) {
        return rtf.format(minutes, 'minute');
    } else if (Math.abs(hours) < 24) {
        return rtf.format(hours, 'hour');
    } else if (Math.abs(days) < 30) {
        return rtf.format(days, 'day');
    } else if (Math.abs(months) < 12) {
        return rtf.format(months, 'month');
    } else {
        return rtf.format(years, 'year');
    }
}